import { Box, Typography } from "@mui/material";
import { FileUploader } from "react-drag-drop-files";
import { compressImage } from "../lib/global";
import { useEffect } from "react";
import Image from "next/legacy/image";

export function ImageFileUpload({
  image,
  setImage,
  initial,
  title,
  imgLimit,
  onChange,
}) {
  useEffect(() => {
    !image && setImage(initial);
  }, [image, initial, setImage]);

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        width: "100%",
        height: "100%",
        rowGap: "8px",
      }}
    >
      <FileUploader
        hoverTitle=" "
        name="profImage"
        types={["jpeg", "png", "jpg", "GIF"]}
        maxSize={100}
        handleChange={(file) => {
          compressImage(file).then((r) => {
            setImage(r);
            onChange(true);
          });
        }}
        children={
          <Box
            sx={{
              flexGrow: 1,
              borderRadius: 2,
              cursor: "pointer",
              p: 1,
              backgroundSize: "cover",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              overflow: "hidden",
              height: { xs: "111px", sm: "130px" },
              background: "rgba(255, 255, 255, 0.6)",
              border: "1px solid #4D4E4E",
              borderRadius: "10px",
            }}
          >
            {image ? (
              <Image
                src={image}
                alt={title}
                width="110%"
                height="110%"
                objectFit="cover"
                sx={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            ) : (
              <>
                <Image
                  src="/assets/cloudIcon.png"
                  width={34}
                  height={25}
                  alt="cloud icon"
                />
                <Typography
                  variant="caption"
                  color="#4D4E4E"
                  sx={{ marginTop: "8px", lineHeight: "15px", width: "62px" }}
                >
                  {imgLimit}
                </Typography>
              </>
            )}
          </Box>
        }
      />
      <Box className="flex justify-content-center">
        <h2 className="profileImageTitle">{title}</h2>
      </Box>
    </Box>
  );
}

export function FileUpload({ file, setFile, initial, title, onChange, type }) {
  useEffect(() => {
    !file && setFile(initial);
  }, [file, initial, setFile]);

  return (
    <Box>
      <FileUploader
        hoverTitle=" "
        name="userCertificate"
        types={["pdf"]}
        maxSize={100}
        handleChange={(file) => {
          const fileObj = { userCertificate: file };
          setFile(file);
          onChange(true);
        }}
        children={
          <Box
            sx={{
              flexGrow: 1,
              borderRadius: 2,
              cursor: "pointer",
              p: 1,
              backgroundSize: "cover",
              textAlign: "center",
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              justifyContent: "center",
              position: "relative",
              overflow: "hidden",
              height: "76px",
              width: "76px",
              background: "rgba(255, 255, 255, 0.6)",
              border: "1px solid #4D4E4E",
              borderRadius: "10px",
            }}
          >
            {file ? (
              <Image
                src={file}
                alt={title}
                width="110%"
                height="110%"
                objectFit="cover"
                sx={{
                  position: "absolute",
                  left: "50%",
                  top: "50%",
                  transform: "translate(-50%, -50%)",
                }}
              />
            ) : (
              <>
                <Image
                  src="/assets/cloudIcon.png"
                  width={25}
                  height={20}
                  alt="cloud icon"
                />
                <Typography
                  variant="caption"
                  color="#4D4E4E"
                  sx={{ marginTop: "8px", lineHeight: "15px", width: "62px" }}
                >
                  .pdf
                </Typography>
              </>
            )}
          </Box>
        }
      />
    </Box>
  );
}
